import { render } from "./detail-transaksi-penjualan-hasil-sync.vue?vue&type=template&id=2d4bab88"
import script from "./detail-transaksi-penjualan-hasil-sync.vue?vue&type=script&lang=js"
export * from "./detail-transaksi-penjualan-hasil-sync.vue?vue&type=script&lang=js"
script.render = render

export default script